import { render, staticRenderFns } from "./Managers.view.vue?vue&type=template&id=769966a8"
import script from "./Managers.view.vue?vue&type=script&lang=ts"
export * from "./Managers.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports